export default __webpack_public_domain__ + __webpack_public_url__ + __webpack_public_path__ + "static/media/pc_logo.png?v=310b9c19";